import { TableHead, TableRow, TableCell, Typography, alpha } from '@mui/material'
import React from 'react'
import { OrdersNavButtonsDetailed } from '../postionsWidget'

interface OrdersTableHeaderProps {
    tabType: OrdersNavButtonsDetailed;
}
const OrdersTableHeader: React.FC<OrdersTableHeaderProps> = ({ tabType }) => {
    return (
        <TableHead>
            <TableRow sx={{
                height: 32,
                borderBottom: (theme) => `1.5px solid ${theme.palette.background.default}`
            }}>
                <TableCell style={{ width: '46%', padding: '5px', }} sx={{ borderBottom: (theme) => `1.5px solid ${theme.palette.background.default}` }}>
                    <Typography variant="caption" color="textSecondary">SYMBOL</Typography>
                </TableCell>
                <TableCell sx={{ padding: 0, textAlign: 'center', width: '5%', borderBottom: (theme) => `1.5px solid ${theme.palette.background.default}` }} />
                <TableCell sx={{ padding: 0, textAlign: 'right', width: '22%', borderBottom: (theme) => `1.5px solid ${theme.palette.background.default}` }}>
                    <Typography variant="caption" color="textSecondary">FILL/QTY</Typography>
                </TableCell>
                <TableCell sx={{
                    width: '15%',
                    padding: '5px',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    borderBottom: (theme) => `1.5px solid ${theme.palette.background.default}`
                }}>
                    <Typography variant="caption" color="textSecondary">PRICE/TRIG.</Typography>
                </TableCell>
                {tabType === OrdersNavButtonsDetailed.OPEN ? <TableCell sx={{
                    padding: 0,
                    paddingRight: '2px',
                    textAlign: 'right',
                    width: '13%',
                    borderBottom: (theme) => `1.5px solid ${theme.palette.background.default}`
                }}>
                    <Typography variant="caption" color="textSecondary">LTP/MTM</Typography>
                </TableCell> : <TableCell sx={{
                    padding: 0,
                    paddingRight: '2px',
                    textAlign: 'right',
                    width: '13%',
                    borderBottom: (theme) => `1.5px solid ${theme.palette.background.default}`
                }}>
                    <Typography variant="caption" color="textSecondary">AVG</Typography>
                </TableCell>}
            </TableRow>
        </TableHead>
    )
}

export default OrdersTableHeader
